import CustomCard from "../../../../../../../components/CustomCard";
import {
    IconCardFillMonitor,
    PlusIconsOptions
} from "../../../../../../../components/buttons/IconButtons";
import CustomTooltip from "../../../../../../../components/CustomTooltip";

/**
 * Author: Arnulfo Ferro Zapata
 * Job Title: Fullstack
 * Email: azpata@ibl.mx
 * Created At: 29 de 05 de 2026
 */

/**
 * Available device card for the shift access Add tab. Shows the device name
 * with an add action. Mirrors the Devices DepartmentTotalEmployeesCard layout
 * without the employee count.
 *
 * @param {Object} props
 * @param {Object} props.item - Device row ({ [keyId], fullName, disabled }).
 * @param {Function} props.onAdd - Callback invoked with the item when added.
 * @returns {JSX.Element}
 */
const DevicesCard = ({item, onAdd}) => {
    return (
        <>
            <CustomCard
                classes="w-100"
                classCard="card-border-8px"
                classContent={`background-shades-50 ${item?.disabled ? 'disable-card-item' : 'background-hover-shades-100' }`}
            >
                <div className="row align-items-center">
                    <div className={`col-10 pr-0`}>
                        <div className="d-flex align-items-center justify-content-between">
                            <div><IconCardFillMonitor className="mr-8px mb-1" /></div>
                            <div className={`flex-grow-1 minw-0`}>
                                <CustomTooltip
                                    text={item?.fullName}
                                    classes={`fs-14px font-color-general-950 ibl-font-w-600 text-ellipsis-1-row `}
                                    showIfTruncated={true}
                                />
                            </div>
                        </div>
                    </div>
                    <div className='col-2'>
                        <div className={"d-flex justify-content-end"}>
                            <PlusIconsOptions
                                id={`btn_dc_add_${item?.id}`}
                                className={`plus-icons-options icon-color-shades-400`}
                                onClick={() => onAdd(item)}
                            />
                        </div>
                    </div>
                </div>
            </CustomCard>
        </>
    );
}

export default DevicesCard
